import { wrapCall, callGet } from './helpers'

//* ~~~~~~ BILLING ROUTE ~~~~~~

// Gets payment methods
export const getMethods = async () => {
  return await wrapCall({ method: callGet, uri: '/billing/methods' })
}

// Gets invoices
export const getInvoices = async () => {
  return await wrapCall({ method: callGet, uri: '/billing/invoices' })
}

// Gets subscription information
export const getSubscriptions = async () => {
  return await wrapCall({ method: callGet, uri: '/billing/subscriptions' })
}
